module.exports = __webpack_public_path__ + "static/img/update-bk.69fd1637.png";